import { render, staticRenderFns } from "./catalog-folders.vue?vue&type=template&id=3075919d"
import script from "./catalog-folders.vue?vue&type=script&lang=js"
export * from "./catalog-folders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports